<template>
  <FormModal :title="headTitle" show-back-btn>
    <template #body>
      <EstimatedNumberOfFramesWhatTypeOfFramesFormStep
        :progress-value="progressValue"
      />
    </template>
  </FormModal>
</template>

<script>
// PD-10940: variant-only step.
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import EstimatedNumberOfFramesWhatTypeOfFramesFormStep from '~/components/form/steps/estimatedNumberOfFramesWhatTypeOfFrames/EstimatedNumberOfFramesWhatTypeOfFramesFormStep.PD-10940'

export default {
  components: {
    EstimatedNumberOfFramesWhatTypeOfFramesFormStep,
    FormModal,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Geschat aantal ramen',
      headDescription:
        'Geef aan hoeveel ramen u wilt laten plaatsen en om wat voor type het gaat.',
      path: '/offertes-aanvragen/geschat-aantal-ramen',
      checkoutStep: 3,
      progressValue: 70,
    }
  },
}
</script>
